import React from "react";

/**
 * Function for rendering an unsuitable filled icon.
 *
 * @param {string} cls - className for the SVG icon
 * @return {JSX.Element} SVG icon component
 */
export const UnsuitableFilledIcon = ({ cls = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <path
        d="M21.2428 14.9576L14.5046 4.62312C13.9375 3.82941 12.9951 3.35156 12.0027 3.35156C11.0103 3.35156 10.068 3.82131 9.47588 4.64742L2.77097 14.9414C1.92034 16.1238 1.76189 17.5412 2.35399 18.6346C2.93776 19.7279 4.16365 20.3516 5.69811 20.3516H18.3074C19.8502 20.3516 21.0677 19.7279 21.6515 18.6346C22.2352 17.5412 22.0768 16.1319 21.2428 14.9576ZM11.1688 8.21102C11.1688 7.76557 11.5441 7.40111 12.0027 7.40111C12.4614 7.40111 12.8367 7.76557 12.8367 8.21102V13.0705C12.8367 13.5159 12.4614 13.8804 12.0027 13.8804C11.5441 13.8804 11.1688 13.5159 11.1688 13.0705V8.21102ZM12.0027 17.9299C11.3106 17.9299 10.7518 17.3873 10.7518 16.7151C10.7518 16.0428 11.3106 15.5002 12.0027 15.5002C12.6949 15.5002 13.2537 16.0428 13.2537 16.7151C13.2537 17.3873 12.6949 17.9299 12.0027 17.9299Z"
        fill="currentColor"
      />
    </svg>
  );
};
